import type { ReactNode, Ref } from 'react';
import { useEffect, useImperativeHandle, useState } from 'react';

import { ModalStateless } from './ModalStateless';

interface ModalProps {
  title: string;
  className?: string | undefined;
  buttons?: ReactNode;
  children: ReactNode;
  open?: boolean;
  onClose?: () => void;
  ref?: Ref<ModalComponent>;
}

export interface ModalComponent {
  open: () => void;
  close: () => void;
}

const Modal = ({ ref, ...props }: ModalProps) => {
  const { open: isOpen, onClose } = props;
  const [modalState, setModalState] = useState(!!isOpen);

  useEffect(() => {
    if (isOpen !== undefined) {
      setModalState(isOpen);
    }
  }, [isOpen]);

  useImperativeHandle(ref, () => ({
    open() {
      setModalState(true);
    },
    close() {
      setModalState(false);
    },
  }));

  const handleClose = () => {
    setModalState(false);
    if (onClose) {
      onClose();
    }
  };

  return (
    <ModalStateless
      {...props}
      open={modalState}
      onClose={handleClose}
      className='rounded-3xl'
      size='m'
    />
  );
};

export default Modal;
